
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { VariantType } from '@/types/typography'
import VClamp from 'vue-clamp'
import Typography from '@/components/Rain/Typography/Typography.vue'

@Component<Quote>({
    components: {
        Typography,
        VClamp,
    },
})
export default class Quote extends Vue {
    @Prop({ type: String, required: true })
    public text!: string
    // Gap between vertical line & comment
    @Prop({ type: Boolean, default: false })
    public noGap?: boolean
    @Prop({ type: Number, default: 5 })
    public maxLines?: number
    @Prop({ type: String, required: false, default: 'caption' })
    public readonly variant!: VariantType

    public quoteClampChange(isClamped, event: Event) {
        this.$emit('quoteClampChange', isClamped)
    }
}
